import PageLayer from "@/Layouts/views/PageLayer";
import GroupAccessSettingsLayer from "../../components/GroupAccessSettings/GroupAccessSettingsLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/settings/GroupSettingsIcon.svg";

export default function GroupAccessSettings() {
	return (
		<PageLayer
			title={"Group Settings"}
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="0 -3 24 24" className="text-[var(--light-blue-color)] !fill-none !text-[28px]" component={Icon} />
				</Stack>
			}
		>
			<GroupAccessSettingsLayer />
		</PageLayer>
	);
}
